import Mockman from "mockman-js";

export const MockMan = () => {
  return <Mockman />;
};
